module.exports = __webpack_public_path__ + "media/brands/ferro-ea25371b.png";